import React from 'react';
import {
  House,
  ChatCircle,
  ChartBar,
  Books,
  Users,
  Robot,
  ChartLineUp,
  Gear,
  Chalkboard,
  Buildings,
  Key,
} from '@phosphor-icons/react';

/**
 * Shared navigation items for student pages.
 */
export const studentNavItems = [
  { label: 'My Dashboard', path: '/student/dashboard', icon: <House size={18} weight="bold" /> },
  { label: 'Start Learning', path: '/student/chat', icon: <ChatCircle size={18} weight="bold" /> },
];

/**
 * Shared navigation items for teacher pages.
 * Used by TeacherDashboard, StudentDetailPage, AnalyticsPage, InsightsPage, SettingsPage, etc.
 */
export const teacherNavItems = [
  { label: 'Dashboard', path: '/teacher/dashboard', icon: <ChartBar size={18} weight="bold" /> },
  { label: 'My Classes', path: '/teacher/classes', icon: <Books size={18} weight="bold" /> },
  { label: 'My Students', path: '/teacher/students', icon: <Users size={18} weight="bold" /> },
  { label: 'AI Insights', path: '/teacher/insights', icon: <Robot size={18} weight="bold" /> },
  { label: 'Analytics', path: '/teacher/analytics', icon: <ChartLineUp size={18} weight="bold" /> },
  { label: 'Settings', path: '/teacher/settings', icon: <Gear size={18} weight="bold" /> },
];

export const schoolAdminNavItems = [
  { label: 'Dashboard', path: '/school-admin/dashboard', icon: <ChartBar size={18} weight="bold" /> },
  { label: 'Teachers', path: '/school-admin/teachers', icon: <Chalkboard size={18} weight="bold" /> },
  { label: 'Students', path: '/school-admin/students', icon: <Users size={18} weight="bold" /> },
  { label: 'Analytics', path: '/school-admin/analytics', icon: <ChartLineUp size={18} weight="bold" /> },
  { label: 'Settings', path: '/school-admin/settings', icon: <Gear size={18} weight="bold" /> },
];

export const superAdminNavItems = [
  { label: 'Dashboard', path: '/super-admin/dashboard', icon: <ChartBar size={18} weight="bold" /> },
  { label: 'Schools', path: '/super-admin/schools', icon: <Buildings size={18} weight="bold" /> },
  { label: 'Platform Analytics', path: '/super-admin/analytics', icon: <ChartLineUp size={18} weight="bold" /> },
  { label: 'Activation Codes', path: '/super-admin/codes', icon: <Key size={18} weight="bold" /> },
  { label: 'Settings', path: '/super-admin/settings', icon: <Gear size={18} weight="bold" /> },
];
